import CreateCompanyInfoFormController from './controller/CreateCompanyInfoFormController.js'
const template = require('./createCompanyInfoForm.component.tpl.pug')

const createCompanyInfoForm = {
  controller: CreateCompanyInfoFormController,
  template: template()
}

export default createCompanyInfoForm
